import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { submitVerificationCode, resend } from "./thunk";
import { FaCheck } from "react-icons/fa";
import { IoIosArrowBack } from "react-icons/io";
import StepperInputs from "@components/StepperInputs";
import DefaultOrangeButton from "@modules/Components/DefaultOrangeButton";
import SmallButtonSpinner from "@components/SmallButtonSpinner";
import styled from "@emotion/styled";
import { flowGo } from "./action";

const ResendSuccess = styled.span`
  color: #39c876;
  font-size: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
`;

const Header = styled.div`
  font-size: 30px;
  font-weight: 500;
  text-align: center;
  color: #1f2021;
`;

const EnterCodeHeader = styled(Header)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @media (max-width: 375px) {
    font-size: 27px;
  }
  @media (max-width: 330px) {
    font-size: 24px;
  }
  @media (max-width: 300px) {
    font-size: 22px;
  }
`;

const BackArrow = styled(IoIosArrowBack)`
  color: rgba(119, 121, 132, 0.5);
  position: absolute;
  font-size: 30px;
  left: 0;
  cursor: pointer;

  @media (max-width: 375px) {
    font-size: 27px;
  }
  @media (max-width: 330px) {
    font-size: 24px;
  }
  @media (max-width: 300px) {
    font-size: 22px;
  }
`;

const ResendContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 31px;
`;

const Resend = styled.span`
  cursor: pointer;
  font-size: 16px;
  text-align: center;
  color: #1f2021;
`;

const EnterCode = ({ type, orderUUID }) => {
  const dispatch = useDispatch();
  const submitAttempts = useSelector(
    state => state.orderVerification.submitAttempts
  );

  const [verificationCode, setVerificationCode] = useState();
  const [valid, setValid] = useState(false);
  const [codeError, setCodeError] = useState("");
  const [loadSpinner, setLoadSpinner] = useState(false);
  const [resendText, changeResendText] = useState("Resend code");

  const submitHandler = async () => {
    if (!valid) {
      return;
    }
    setLoadSpinner(true);
    const error = await dispatch(
      submitVerificationCode({
        code: verificationCode,
        type: type,
        orderId: orderUUID
      })
    );

    if (error) {
      setCodeError(error);
      setValid(false);
      setLoadSpinner(false);
    }
  };

  const handleResendCode = () => {
    const response = dispatch(resend(type, orderUUID));
    if (response) {
      changeResendText(
        <ResendSuccess>
          <FaCheck
            style={{
              marginRight: "5px",
              fontSize: "16px"
            }}
          />
          Code resent
        </ResendSuccess>
      );
    }
  };
  return (
    <div className="enter-code-verify">
      <EnterCodeHeader>
        <BackArrow onClick={() => dispatch(flowGo("select-phone"))} />
        Enter your code
      </EnterCodeHeader>
      <div>
        <StepperInputs
          setVerificationCode={setVerificationCode}
          setValid={setValid}
          setCodeError={setCodeError}
          codeError={codeError}
          submitHandler={submitHandler}
          submitAttempts={submitAttempts}
          valid={valid}
          length={5}
        />
        <DefaultOrangeButton
          handleClick={submitHandler}
          disabled={!valid}
          classes={"main-default-orange-button"}
        >
          {loadSpinner ? (
            <SmallButtonSpinner img="https://cdn.cardcash.com/website/ui/elements/spinner-white.png" />
          ) : (
            <span>Verify</span>
          )}
        </DefaultOrangeButton>
        <ResendContainer>
          <Resend onClick={handleResendCode}>{resendText}</Resend>
        </ResendContainer>
      </div>
    </div>
  );
};

export default EnterCode;
